import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const getInvoicePayments =
  (id, page = 1, page_size = 100) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoicepayments/?invoice__is_public=${
          store.getState().auth.Protected ? true : ""
        }&invoice__id=${id}&page=${page}&page_size=${page_size}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getSpecificInvoicePayment = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/order/invoicepayments/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllInvoicePayments =
  (page = 1, page_size = 100, keyword = "", filters = {}) =>
  async (dispatch) => {
    try {
      const { start, end } = filters;
      const response = await backend.get(
        `api/order/invoicepayments/?invoice__is_public=${
          store.getState().auth.Protected ? true : ""
        }&keyward=${keyword}&start=${start || ""}&end=${end || ""}&page=${page}&page_size=${page_size}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
